import React, { useEffect, useState } from "react";
import { DISTRIBUTOR } from "../../constants/fetchData";
import {
  HugeiconsReceiptDollar,
  TablerCashRegister,
  TablerRocket,
} from "../../assets/icons/DashboardIcon";
import { getDashboardHeaders } from "../../services/dashboardService";

const Header = ({ userRole, setDistributor, distributor }) => {
  const [activeTab, setActiveTab] = useState("Day");
  const [stats, setStats] = useState(null); // <-- Add state for stats

  const baseTitles = [
    { title: "Total sales", icon: TablerCashRegister },
    { title: "Total leads", icon: TablerRocket },
    { title: "Total revenue", icon: HugeiconsReceiptDollar },
  ];

  const extractValues = (period) =>
    stats && stats[period]
      ? [
          stats[period][0], // totalSales
          stats[period][1], // totalLeads
          stats[period][3], // totalRevenue (skip index 2)
        ]
      : ["0", "0", "0"];

  const values = {
    Day: extractValues("Day"),
    Week: extractValues("Week"),
    Month: extractValues("Month"),
    Year: extractValues("Year"),
    // Overall: extractValues("Overall"), // Optional
  };

  const handleDistributorChange = async (e) => {
    const distributorName = e.target.value;
    setDistributor(distributorName);
  };

  const getDashboardHeaderDetails = async () => {
    try {
      const result = await getDashboardHeaders({
        category: "sales tracking",
      });
      if (result && result.data) {
        setStats(result.data); // <-- Update the stats here
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    getDashboardHeaderDetails();
  }, []);

  return (
    <div className="px-0 sm:px-4 space-y-6 pt-4">
      <div className="grid lg:flex justify-between gap-2">
        <h1 className="text-2xl sm:text-3xl  leading-9 font-bold text-text1">
          Sales insights
        </h1>
        <div className="flex gap-2.5">
          {["Day", "Week", "Month", "Year"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`button ${activeTab === tab ? "active" : "inactive"}`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-5 mb-3">
        {baseTitles.map((item, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg p-6 flex justify-between items-center w-full shadow-lg"
          >
            <div>
              <h2 className="text-sm font-medium text-text1 text-left">
                {item.title}
              </h2>
              <p className="text-3xl font-bold text-text1 text-left">
                {item.title === "Total revenue" && "₹"}
                {values[activeTab][index]}
              </p>
            </div>
            <item.icon className="text-gray-300 text-4xl" />
          </div>
        ))}
      </div>
      <hr className="mt-2 border-gray-300" />
    </div>
  );
};

export default Header;
